import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { preloadImages, preloadImagesIdle } from '../utils/imagePreloader';
import {
  BACKGROUND_IMAGES,
  CRITICAL_IMAGES,
  HOME_MENU_ICONS,
  HOME_QUICK_ACTIONS,
  ROUTE_IMAGE_MAP,
} from '../utils/staticImages';

export function useAppImageWarmup() {
  const location = useLocation();

  useEffect(() => {
    preloadImages(CRITICAL_IMAGES, { priority: 'high', limit: 6 });
    preloadImagesIdle(BACKGROUND_IMAGES);
    preloadImagesIdle([...HOME_MENU_ICONS, ...HOME_QUICK_ACTIONS]);
  }, []);

  useEffect(() => {
    const routeImages = ROUTE_IMAGE_MAP[location.pathname];
    if (!routeImages?.length) return;

    preloadImages(routeImages.slice(0, 4), { priority: 'high' });
    preloadImagesIdle(routeImages.slice(4));
  }, [location.pathname]);
}
